import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BvnIntroComponent } from './bvn-intro.component';
import { SharedModule } from '@app/shared/shared.module';



export const routes: Routes = [{ path: "", component : BvnIntroComponent}]

@NgModule({
  declarations: [
    BvnIntroComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes)
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class BvnIntroModule { }
